import {
  Box,
  Container,
  Flex,
  Heading,
  Text,
  VStack,
  Spinner,
} from '@chakra-ui/react'
import { SignIn } from '@clerk/clerk-react'
import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import UserbackWidget from '../components/UserbackWidget'
import { useAuth } from '../contexts/AuthContext'

export default function Login() {
  const { loading, isAuthEnabled, isSignedIn } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const from = (location.state as { from?: { pathname: string } })?.from?.pathname || '/app'

  useEffect(() => {
    if (isSignedIn) {
      navigate(from, { replace: true })
    }
  }, [isSignedIn, navigate, from])

  if (loading) {
    return (
      <Flex h="100vh" w="100vw" align="center" justify="center" bg="background.light">
        <VStack spacing={4}>
          <Spinner size="xl" color="brand.500" thickness="4px" />
          <Text color="text.secondary">Loading...</Text>
        </VStack>
      </Flex>
    )
  }

  if (!isAuthEnabled) {
    return (
      <Flex h="100vh" w="100vw" align="center" justify="center" bg="background.light">
        <VStack spacing={4}>
          <Text color="text.secondary">Authentication is disabled in development mode.</Text>
          <Text 
            color="brand.500" 
            cursor="pointer" 
            onClick={() => navigate('/app')}
            _hover={{ textDecoration: 'underline' }}
          >
            Go to App
          </Text>
        </VStack>
      </Flex>
    )
  }

  return (
    <>
      <Flex h="100vh" w="100vw" align="center" justify="center" bg="background.light">
        <Container maxW="container.sm">
          <VStack spacing={8}>
            <Box>
              <img
                src="/axone_logo.png"
                alt="Axone Logo"
                style={{
                  height: '120px',
                  width: 'auto',
                  marginBottom: '0',
                }}
              />
            </Box>

            <VStack spacing={2} style={{ marginTop: '-2rem' }}>
              <Heading
                size="2xl"
                fontWeight="700"
                letterSpacing="-0.02em"
                color="text.primary"
                textAlign="center"
              >
                Welcome to Axone
              </Heading>
              <Text fontSize="lg" color="text.secondary" textAlign="center">
                Sign in to access the simulation platform
              </Text>
            </VStack>

            <Box
              w="100%"
              display="flex"
              justifyContent="center"
            >
              <SignIn 
                routing="hash"
                signUpUrl="/login"
                afterSignInUrl={from}
                appearance={{
                  elements: {
                    rootBox: {
                      width: '100%',
                      maxWidth: '400px',
                    },
                    card: {
                      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                      borderRadius: '12px',
                    },
                    headerTitle: {
                      display: 'none',
                    },
                    headerSubtitle: {
                      display: 'none',
                    },
                    socialButtonsBlockButton: {
                      borderRadius: '8px',
                      border: '2px solid #e2e8f0',
                      '&:hover': {
                        borderColor: '#38a169',
                        boxShadow: '0 0 0 3px rgba(56, 161, 105, 0.2)',
                      },
                    },
                    formButtonPrimary: {
                      backgroundColor: '#38a169',
                      '&:hover': {
                        backgroundColor: '#2f855a',
                      },
                    },
                    footerActionLink: {
                      color: '#38a169',
                      '&:hover': {
                        color: '#2f855a',
                      },
                    },
                  },
                }}
              />
            </Box>

            <VStack spacing={2}>
              <Text fontSize="sm" color="text.secondary" textAlign="center">
                Need help? Contact vyasabhishek@pm.me
              </Text>
            </VStack>
          </VStack>
        </Container>
      </Flex>
      <UserbackWidget />
    </>
  )
}
